import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { customAssetOrSrc } from '@core/assets/customAssetOrSrc';
import { Play } from '@core/assets/Play';
import { AccessibleIcon } from '@core/components/AccessibleIcon/AccessibleIcon';
import { useContextTranslation } from '@core/i18n';
import { useStore } from '@core/widgets/store';
const IconButton = styled('button') `
  background-color: transparent;
  border-radius: 50%;
  border: 0;
  bottom: auto;
  box-sizing: border-box;
  color: inherit;
  left: 50%;
  margin: 0 !important;
  padding: 0 !important;
  position: absolute;
  right: auto;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  transform: translate(-50%, -50%);
`;
/**
 *
 */
const PlayButton = (props) => {
    const { hidePlayIcon, isLarge, isSmall, mode, ...rest } = props;
    const { t } = useContextTranslation();
    const params = useStore((state) => state.params);
    // Only apply large/small if mode is 'stories', otherwise always medium
    let sizeCSS = 'height: 50px; width: 50px;';
    if (mode === 'stories') {
        if (isLarge) {
            sizeCSS = 'height: 80px; width: 80px;';
        }
        else if (isSmall) {
            sizeCSS = 'height: 30px; width: 30px;';
        }
    }
    return (<IconButton {...rest} css={css `
        ${sizeCSS}
      `}>
      {!hidePlayIcon && (<AccessibleIcon src={customAssetOrSrc(params?.ui_asset_play) || (<Play circle label="" aria-hidden/>)} height="100%" width="100%" label={t('Play')}/>)}
    </IconButton>);
};
export default PlayButton;
